/**
 * Short stable FNV-1a hash of an audio device label, so telemetry can
 * correlate "same device" without shipping the label itself (device labels
 * routinely embed a personal name, e.g. "Jane's AirPods").
 */
export function hashDeviceLabel(label: string | null | undefined): string | null {
  if (!label) return null;
  let hash = 0x811c9dc5;
  for (let i = 0; i < label.length; i++) {
    hash ^= label.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(36);
}
